import { DEMO_LABS, getDone } from "./robotLab";
import { COURSES } from "./advancedCourses";

const LESSONS = "rs_course_lessons_done";
const NAME = "rs_cert_name";

export const getLessons = () => { try { return JSON.parse(localStorage.getItem(LESSONS)) || {}; } catch { return {}; } };
export const markLesson = (id) => { if (!getLessons()[id]) localStorage.setItem(LESSONS, JSON.stringify({ ...getLessons(), [id]: new Date().toISOString() })); };
export const getCertName = () => localStorage.getItem(NAME) || "";
export const setCertName = (n) => localStorage.setItem(NAME, n);

export const progress = () => {
  const d = getDone(), ls = getLessons();
  const labs = DEMO_LABS.map((l) => ({ ...l, at: d[l.id] }));
  const courses = COURSES.map((c) => ({ ...c, at: ls[c.id] }));
  const labsDone = labs.filter((l) => l.at).length, lessonsDone = courses.filter((c) => c.at).length;
  const total = labs.length + courses.length;
  const lastLab = labs.filter((l) => l.at).map((l) => l.at).sort().pop();
  return { labs, courses, labsDone, lessonsDone, pct: Math.round(((labsDone + lessonsDone) / total) * 100), allLabs: labsDone === labs.length, lastLab };
};

export const certId = (name, at) => {
  let h = 2166136261;
  for (const ch of `${name.trim().toLowerCase()}|${at}`) h = Math.imul(h ^ ch.charCodeAt(0), 16777619);
  return `RS-LAB-${(h >>> 0).toString(36).toUpperCase().padStart(7, "0")}`;
};
